import { useQuery } from "@tanstack/react-query";
import { UserRoles } from "constants/userRoles";
import { useAuthContext } from "hooks/useAuthContext";
import { WORKSPACE_STORAGE_USAGE_QUERY_KEY } from "./queryKeys";
import { getWorkspaceStorageUsage } from "@api/services/workspace-plan-service";

export const useGetWorkspaceStorageUsage = () => {
  const { userState } = useAuthContext();
  const { workspaceId, userRole } = userState.user.selectedWorkspace;
  const canReadStorage =
    userRole === UserRoles.ADMIN || userRole === UserRoles.Patron;

  return useQuery({
    queryKey: [...WORKSPACE_STORAGE_USAGE_QUERY_KEY, workspaceId],
    queryFn: async () => {
      const response = await getWorkspaceStorageUsage(workspaceId);
      if (!response.success) {
        throw new Error(
          response.message ?? "Unable to load workspace storage usage",
        );
      }
      return response.data ?? null;
    },
    enabled: !!workspaceId && canReadStorage,
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
};
